import { connect } from 'react-redux';
import { withFormik } from 'formik';
import { compose } from 'redux';
import { mergeWith, isArray } from 'lodash';
import { toast } from 'react-toastify';

import { editCandidateAPIFormValues } from './EditCandidate.mapper';
import validationSchema from './EditCandidate.validation';
import { getErrorMessage, getIntlPhoneNumberObject } from '../../../utils/utilities';

import {
  getCategories,
  INVALIDATE_CATEGORIES,
  getTags,
  INVALIDATE_TAGS,
  getCompanyServices,
  getCandidateFormConfig,
  editCandidate,
  deleteCandidate
} from '../../../actions/company';

import {
  bgvUrl as bgvUrlAPI,
  deleteCandidate as deleteCandidateAPI,
  editCandidate as editCandidateAPI
} from '../../../api/company';

const mapStateToProps = (state) => {
  return {
    categories: state.categories,
    tags: state.tags,
    companyServices: state.companyServices,
    candidateInfo: state.candidateInfo,
    formConfig: state.formConfig
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    invalidateCategories: () => dispatch({ type: INVALIDATE_CATEGORIES }),
    getCategories: () => dispatch(getCategories()),
    invalidateTags: () => dispatch({ type: INVALIDATE_TAGS }),
    getTags: () => dispatch(getTags()),
    getCompanyServices: () => dispatch(getCompanyServices()),
    bgvUrl: (id) => dispatch(bgvUrlAPI(id)),
    editCandidate: (data) => dispatch(editCandidate(data)),
    getCandidateFormConfig: () => dispatch(getCandidateFormConfig()),
    deleteCandidate: (id) => dispatch(deleteCandidate(id))
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withFormik({
    mapPropsToValues: (props) => {
      let storedValues = {};

      if (props?.candidateDetails) {
        let category = props?.candidateDetails?.candidateUserCategoryMapping?.userCategoryId
          ? props?.candidateDetails?.candidateUserCategoryMapping?.userCategoryId
          : '';

        let tag =
          isArray(props?.candidateDetails?.candidateCompanyCategoryMappings) &&
          props?.candidateDetails?.candidateCompanyCategoryMappings?.length > 0
            ? props?.candidateDetails?.candidateCompanyCategoryMappings.map((value) => ({
                label: value.companyCategory.category,
                value: value.companyCategoryId
              }))
            : [];

        storedValues = {
          name: props.candidateDetails.name,
          email: props.candidateDetails.email,
          employeeId: props.candidateDetails.companyCandidateMapping?.employeeId,
          uanNumber: props.candidateDetails.companyCandidateMapping?.uanNumber || '',
          gender: props.candidateDetails.gender || null,
          resumeLink: props.candidateDetails.companyCandidateMapping?.resumeFormat ? true : false,
          category,
          tag,
          type: 'candidate'
        };

        if (props.candidateDetails.companyCandidateMapping?.phoneNumber) {
          let phoneNumberObj = getIntlPhoneNumberObject(
            props.candidateDetails.companyCandidateMapping?.phoneNumber
          );
          if (phoneNumberObj) {
            storedValues['phoneNumber'] = phoneNumberObj.nationalNumber;
            storedValues['countryCode'] = `+${phoneNumberObj.countryCallingCode}`;
          }
        }

        if (props.candidateDetails.companyCandidateMapping?.altPhoneNumber) {
          let altPhoneNumberObj = getIntlPhoneNumberObject(
            props.candidateDetails.companyCandidateMapping?.altPhoneNumber
          );
          if (altPhoneNumberObj) {
            storedValues['altPhone'] = altPhoneNumberObj.nationalNumber;
            storedValues['altCountryCode'] = `+${altPhoneNumberObj.countryCallingCode}`;
          }
        }
      }
      return mergeWith(
        {
          name: '',
          email: '',
          emailExists: false,
          phoneNumber: '',
          phoneNumberExists: false,
          isValidPhone: true,
          isAltValidPhone: true,
          altPhone: '',
          altCountryCode: '+91',
          countryCode: '+91',
          employeeId: '',
          employeeIdExists: false,
          gender: null,
          uanNumber: '',
          resume: '',
          resumeLink: '',
          category: '',
          tag: [],
          type: 'candidate',
          isEdit: false,
          formConfig: {
            isEmailOptional: props?.formConfig?.isEmailOptional, // 0 -> isRequired | 1 -> not required
            isResumeOptional: props?.formConfig?.isResumeOptional,
          }
        },
        storedValues,
        (a, b) => (b === null ? a : b)
      );
    },
    enableReinitialize: true,
    validateOnMount: true,
    validationSchema,
    handleSubmit: (values, { setFieldError, setSubmitting, resetForm, props }) => {
      if (typeof values.resumeLink === 'boolean') {
        delete values.resumeLink;
      }
      if (values.emailExists) {
        setFieldError('email', 'Email already exists');
        setSubmitting(false);
      } else if (values.phoneNumberExists) {
        setFieldError('phoneNumber', 'Phone number already exists');
        setSubmitting(false);
      } else if (values.employeeIdExists) {
        setFieldError('employeeId', 'Employee Id already exists');
        setSubmitting(false);
      } else if (values.emailInvalid) {
        setFieldError('email', 'Invalid Email');
        setSubmitting(false);
      } else {
        values.uanNumber = values.uanNumber || '';
        if (values.isEdit) {
          values.candidateId = props.candidateDetails.companyCandidateMapping.candidateId;
          values.companyCandidateMappingId = props.candidateDetails.companyCandidateMapping.id;
          editCandidateAPI(editCandidateAPIFormValues(values))
            .then((response) => {
              setSubmitting(false);
              values.isEdit = false;
              props.onModalHide('reloadCandidate');
            })
            .catch((error) => {
              toast.error(getErrorMessage(error));
              setSubmitting(false);
              values.isEdit = false;
            });
        }
      }
    },
    displayName: 'Edit Candidate'
  })
);
